var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 36,
    viewBox: "0 0 60 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(-602 -465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person",
    d: "M21.587,8.161a3.614,3.614,0,0,1,1.529.321,3.908,3.908,0,0,1,2.209,3.493V22.132a1.076,1.076,0,0,1-2.152,0V12.541c-.165-.547-1.221-.32-1.246,0V34.555c-.269,2.248-3.173,1.588-3.247-.038V21.037c-.186-.869-1.408-.474-1.435.038.052,4.481.038,8.961.038,13.442a1.634,1.634,0,0,1-3.247.038L14,12.541c-.169-.535-1.148-.33-1.171,0v9.591a1.076,1.076,0,0,1-2.152,0V11.975A3.888,3.888,0,0,1,12.45,8.482a3.107,3.107,0,0,1,1.473-.321h7.665Zm-.038-4.613A3.548,3.548,0,1,1,18,0a3.548,3.548,0,0,1,3.548,3.548Z",
    transform: "translate(591.325 465)",
    fill: "#bf0a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "person-2",
    "data-name": "person",
    d: "M21.587,8.161a3.614,3.614,0,0,1,1.529.321,3.908,3.908,0,0,1,2.209,3.493V22.132a1.076,1.076,0,0,1-2.152,0V12.541c-.165-.547-1.221-.32-1.246,0V34.555c-.269,2.248-3.173,1.588-3.247-.038V21.037c-.186-.869-1.408-.474-1.435.038.052,4.481.038,8.961.038,13.442a1.634,1.634,0,0,1-3.247.038L14,12.541c-.169-.535-1.148-.33-1.171,0v9.591a1.076,1.076,0,0,1-2.152,0V11.975A3.888,3.888,0,0,1,12.45,8.482a3.107,3.107,0,0,1,1.473-.321h7.665Zm-.038-4.613A3.548,3.548,0,1,1,18,0a3.548,3.548,0,0,1,3.548,3.548Z",
    transform: "translate(614 465)",
    fill: "#bf0a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "person-3",
    "data-name": "person",
    d: "M21.587,8.161a3.614,3.614,0,0,1,1.529.321,3.908,3.908,0,0,1,2.209,3.493V22.132a1.076,1.076,0,0,1-2.152,0V12.541c-.165-.547-1.221-.32-1.246,0V34.555c-.269,2.248-3.173,1.588-3.247-.038V21.037c-.186-.869-1.408-.474-1.435.038.052,4.481.038,8.961.038,13.442a1.634,1.634,0,0,1-3.247.038L14,12.541c-.169-.535-1.148-.33-1.171,0v9.591a1.076,1.076,0,0,1-2.152,0V11.975A3.888,3.888,0,0,1,12.45,8.482a3.107,3.107,0,0,1,1.473-.321h7.665Zm-.038-4.613A3.548,3.548,0,1,1,18,0a3.548,3.548,0,0,1,3.548,3.548Z",
    transform: "translate(636.675 465)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart9);
export default __webpack_public_path__ + "static/media/chart9.df287bbe5977fa69324c64a0c3cef41e.svg";
export { ForwardRef as ReactComponent };